import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import * as Sentry from '@sentry/react';
import { enGB, lt } from 'date-fns/locale';

import React from 'react';

import LoadingScreen, { ProgressBarStyle } from 'components/LoadingScreen/LoadingScreen';
import NotistackProvider from 'components/NotistackProvider/NotistackProvider';
import ScrollToTop from 'components/ScrollToTop/ScrollToTop';
import useAuth from 'hooks/useAuth';
import useLocales from 'hooks/useLocales';
import Router from 'routes';
import ThemeConfig from 'theme';
import GlobalStyles from 'theme/globalStyles';

import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';

// Sentry.init({
//     dsn: 'https://0e248f7406216a56190e53dcfa088a28@o4510262537355264.ingest.de.sentry.io/4510262541418576',
//     integrations: [Sentry.browserTracingIntegration(), Sentry.captureConsoleIntegration({ levels: ['error'] })],
//     // Tracing
//     tracesSampleRate: 1.0, //  Capture 100% of the transactions
//     // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//     tracePropagationTargets: ['localhost', /^https:\/\/cak\.lt/],
//     // Session Replay
//     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

Sentry.init({
    dsn: 'https://0e248f7406216a56190e53dcfa088a28@o4510262537355264.ingest.de.sentry.io/4510262541418576',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
});

const App: React.FunctionComponent = () => {
    const { isInitialized } = useAuth();
    const { currentLang } = useLocales();

    return (
        <ThemeConfig>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={currentLang.value === 'lt' ? lt : enGB}>
                <CollapseDrawerProvider>
                    <NotistackProvider>
                        <GlobalStyles />
                        <ProgressBarStyle />
                        <ScrollToTop />
                        {isInitialized ? <Router /> : <LoadingScreen />}
                    </NotistackProvider>
                </CollapseDrawerProvider>
            </LocalizationProvider>
        </ThemeConfig>
    );
};

export default App;
